import { CopyOutlined } from '@ant-design/icons';
import { message } from 'antd';
import React from 'react';

interface CopyableTextProps {
  value: string;
  children?: React.ReactNode;
  successMessage?: string;
}

export function CopyableText({ value, children, successMessage = 'ID가 클립보드에 복사되었습니다.' }: CopyableTextProps) {
  const [isHovered, setIsHovered] = React.useState(false);

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    await navigator.clipboard.writeText(value);
    message.success(successMessage);
  };

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick(e as unknown as React.MouseEvent)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ cursor: 'pointer', color: '#999', fontSize: 12 }}
    >
      {children || value}
      <CopyOutlined
        style={{
          marginLeft: 4,
          opacity: isHovered ? 1 : 0,
          transition: 'opacity 0.3s ease',
        }}
      />
    </span>
  );
}
